#import "../fragments/pinned-info-fragment.graphql"

mutation SetPinnedEntity($input: SetEntityPinnedStatusInput!) {
    setEntityPinnedStatus(input: $input) {
        pinnedInfo {
            ...PinnedInfoFragment
        }
    }
}
